exports.components = {
  "component---src-templates-landing-page-template-index-js": () => import("./../../../src/templates/LandingPageTemplate/index.js" /* webpackChunkName: "component---src-templates-landing-page-template-index-js" */)
}

